import { combineEpics } from 'redux-observable';
import { rootEpic as DataSourceListEpic } from './views/DataSourceList/epics';
import { rootEpic as DataSourceDetailEpic } from './views/DataSourceDetail/epics';
import { rootEpic as DataSourceCreateEpic } from './views/DataSourceCreate/epics';
import { rootEpic as DataSourceCreateOverrideEpic } from './views/DataSourceOverrideCreate/epics';
export const rootEpic = combineEpics(DataSourceListEpic, DataSourceDetailEpic, DataSourceCreateEpic, DataSourceCreateOverrideEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
